
export enum BlogStatus {
    Draft,
    Published,
    Expired,
    Archived
}
